// extracted by extract-css-chunks-webpack-plugin
module.exports = {"mapSectionContent":"Location_mapSectionContent-3Agx-"};